// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ud3Z","placeholdersHeader":"styles_placeholdersHeader__3dyug","editorStyle":"styles_editorStyle__dixRs","placeholdersBox":"styles_placeholdersBox__3CAME"};